import React, { ReactElement } from "react";
import * as app from "../services/AppService"; 
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';

interface CheckboxProps extends RowItem, Omit<InterfaceComponentsProps,"Icon">  {
    onChange?: (checked: boolean, key: string | undefined) => any;
    model: boolean;
    elmKey?: string | number;
    class?: string; 
}

export default function Checkbox(props: CheckboxProps): ReactElement {
    const inputId = props.id || props.label;

    function handler(event: { target: { checked: boolean } }) {
        const { checked } = event.target;
        props.onChange?.(checked, props.elmKey?.toString());
    }

    let labelTag = <label htmlFor={inputId} className={"ms-2 form-check-label text-primary-emphasis user-select-none c-pointer " + props.labelClass}>
        {app.translate(props.label)}
    </label>;

    let input = (
        <input
            type="checkbox"
            role="button"
            name={inputId}
            id={inputId}
            key={props.elmKey}
            disabled={props.disabled}
            className="form-check-input"
            onChange={handler}
            checked={props.model}
        />
    );

    let IsAr = app.getCookie("language", "en") === "ar";
    const checkBoxContent =
        <div className={props.isTable ? "" : `form-check ${props.class}`}>
            {IsAr ? input : labelTag}
            {IsAr ? labelTag : input}
    </div>
    const hasLabel = !!props.label;
    const hasTooltip = !!props.iconTooltip && !props.disabled;
    if (!hasLabel && hasTooltip) {
        return (
            <OverlayTrigger
                key={(props.elmKey ?? "") + "bottom"}
                placement="bottom"
                overlay={
                    <TooltipElm style={{ position: "fixed" }} id={`tooltip-checkbox-${inputId}`}>
                        {app.translate(props.iconTooltip)}
                    </TooltipElm>
                }
            >
                {checkBoxContent}
            </OverlayTrigger>
        )
    }
    return checkBoxContent;
}

Checkbox.defaultProps = {
    class: "",
    checkClass: "mt-1",
    name: "",
    label: "",
    isTable: false,
    disabled: false,
    className:''
};
